import React from "react";
import type { WarehouseLabelDisplay } from "../../models/WarehouseLabelDisplay";

export type WarehouseLabelTemplateProps = {
  display: WarehouseLabelDisplay;
  qrSrc?: string;
  title?: string;
  subtitle?: string;
};

const safe = (v?: string) => (v ?? "").trim();

export default function WarehouseLabelTemplate({
  display,
  qrSrc,
  title,
  subtitle
}: WarehouseLabelTemplateProps) {
  const t = safe(title);
  const st = safe(subtitle);

  return (
    <html>
      <head>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no"
        />
      </head>
      <body style={{ margin: 0, padding: 0 }}>
        <div
          style={{
            width: "10cm",
            height: "5cm",
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            columnGap: ".25cm"
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {display.qr && qrSrc ? (
              <img style={{ width: "100%" }} src={qrSrc} alt="QR" />
            ) : null}
          </div>

          <div
            style={{
              fontFamily: "Arial,Helvetica,sans-serif",
              fontWeight: 700,
              gridColumn: "span 2 / span 2",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            {display.title && t ? (
              <div style={{ textAlign: "center" }}>{t}</div>
            ) : null}

            {display.subtitle && st ? (
              <div style={{ marginTop: ".5cm", textAlign: "center", fontSize: "20px" }}>
                {st}
              </div>
            ) : null}
          </div>
        </div>
      </body>
    </html>
  );
}
